function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentsActive = function SvgPaymentsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.782 37.334c-16.405 7.81-12.52-10.166-5.962-26.139C18.378-4.777 22.52.002 34.906 5.903c12.386 5.902 24.296 11.577 8.333 17.747-15.028 5.81-9.053 5.875-25.457 13.684Z",
    fill: props.accentFill,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 9v22M31 13h-7.5a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H20",
    fill: "none",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgPaymentsActive;